const products = [
  {
    id: 'vpn',
    name: 'VPN',
    tagline: 'Secure. Private. Fast.',
    description:
      'A powerful VPN application for iOS that encrypts your internet connection, hides your IP address, and protects your data on any network. Designed with a clean, intuitive interface for effortless privacy.',
    highlights: ['Military-grade encryption', 'Zero-log policy', 'Global server network', 'One-tap connection'],
    icon: 'ri-shield-keyhole-line',
    bg: 'from-emerald-50 to-teal-50',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-700',
    accentColor: 'text-emerald-600',
    image: 'https://public.readdy.ai/ai/img_res/765e3584275555bbcd5bc162c9611caf.jpg',
  },
  {
    id: 'cleaner',
    name: 'Cleaner',
    tagline: 'Clean. Optimize. Perform.',
    description:
      'An intelligent iOS cleaner that removes junk files, duplicate photos, and unnecessary data to free up storage and boost your device performance. Keep your iPhone running like new.',
    highlights: ['Smart junk detection', 'Duplicate photo finder', 'Storage analyzer', 'Battery optimizer'],
    icon: 'ri-sparkling-2-line',
    bg: 'from-rose-50 to-pink-50',
    iconBg: 'bg-rose-100',
    iconColor: 'text-rose-600',
    accentColor: 'text-rose-500',
    image: 'https://readdy.ai/api/search-image?query=minimalist%20phone%20cleaner%20app%20interface%20on%20iOS%20device%2C%20sparkle%20and%20broom%20icon%20in%20rose%20pink%20tones%2C%20clean%20white%20and%20blush%20pink%20color%20palette%2C%20abstract%20particles%20floating%20away%2C%20soft%20light%20gradient%2C%20premium%20mobile%20app%20screenshot%20style%2C%20simple%20elegant%20UI%20design%2C%20light%20background&width=480&height=560&seq=prima-cleaner-product&orientation=portrait',
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-20">
          <p className="text-xs uppercase tracking-[0.3em] text-gray-400 mb-4 font-medium">Our Products</p>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 leading-tight">
            Designed for <span className="font-semibold">iOS Excellence</span>
          </h2>
          <p className="mt-5 text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            Each product is crafted with precision to deliver a seamless, secure, and high-performance experience on Apple devices.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {products.map((p) => (
            <div
              key={p.id}
              className={`rounded-3xl bg-gradient-to-br ${p.bg} overflow-hidden flex flex-col`}
            >
              {/* Image area */}
              <div className="relative h-72 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white/60 to-transparent" />
              </div>

              {/* Info panel */}
              <div className="p-8 flex flex-col gap-4">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${p.iconBg}`}>
                    <i className={`${p.icon} text-xl ${p.iconColor}`} />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">{p.name}</h3>
                    <p className={`text-xs font-medium tracking-wide ${p.accentColor}`}>{p.tagline}</p>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{p.description}</p>
                <ul className="grid grid-cols-2 gap-2 mt-1">
                  {p.highlights.map((h) => (
                    <li key={h} className="flex items-center gap-2 text-xs text-gray-500">
                      <span className={`w-1.5 h-1.5 rounded-full ${p.iconBg} ${p.iconColor} flex-shrink-0`} />
                      {h}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
